import React from 'react';
import '../styles/spinner-loader.css';


const Logo: React.FC = () => {
    return (
        <h1 className="text-[2rem] font-extrabold leading-[30px] text-on-surface text-center !font-museo">Zdrowio</h1>
    );
};

export default Logo;
